import $ from "jquery";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/tab";
import placesAutoComplete from "google/places-auto-complete";
import pageData from "common/page-data";

// Set up Google autocomplete in the search modals
placesAutoComplete.initializeCityState(
  ".js-dooh-profile-search-form-city-state",
  null,
  pageData.get("currentCountry")
);
